import { render, staticRenderFns } from "./CompanyListingCard.vue?vue&type=template&id=20542b06&"
import script from "./CompanyListingCard.vue?vue&type=script&lang=js&"
export * from "./CompanyListingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports